import React from "react";
import { Reveal } from "./Reveal";

export const Founder = () => {
  return (
    <section id="founder" data-testid="founder-section" className="relative py-24 md:py-32">
      <div className="w-full max-w-3xl mx-auto px-6 md:px-12">
        <Reveal>
          <div className="flex items-center gap-3 mb-5">
            <span className="h-px w-8 bg-sf-ember" />
            <span className="font-mono text-xs uppercase tracking-[0.3em] text-sf-ember">Founder’s Note</span>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="space-y-5 text-base md:text-lg text-sf-dim leading-relaxed">
            <p>{"I'll be honest with you. I didn't wake up one day wanting to make an oracle deck. For a long time I couldn't even say out loud what I was carrying. You come home, everyone says thank you for your service, and then you're just… sitting in the quiet with all of it."}</p>
            <p>{"A while back I did the Gateway Voyage at the Monroe Institute. There were other vets there, first responders too — people who'd seen the same kind of things I had. Something shifted for me in that room. And afterward one thought kept coming back: there's an oracle deck for just about everything, but nothing that spoke to us — to veterans, to first responders, to the darker, heavier side of what we carry. Everything out there felt too soft for it."}</p>
            <p>
              {"So I built it. It's not soft, and it doesn't pretend the hard days are pretty. It just talks to you straight — the way a buddy would. If you've ever stood in that doorway between who you were and who you're becoming and thought "}
              <span className="text-sf-bone italic">okay, what now</span>
              {", I made this for you."}
            </p>
            <p className="text-sf-bone">{"Thanks for being here. Hold the line — you're not out there alone."}</p>
          </div>
        </Reveal>

        <Reveal delay={0.2}>
          <div className="mt-10 pt-6 border-t border-sf-border">
            <p className="sf-stencil text-2xl text-sf-bone tracking-wide">— Ayanna</p>
            <p className="font-mono text-xs uppercase tracking-[0.2em] text-sf-muted mt-1">
              Veteran · Gateway Voyager · The Owl of Mintaka
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Founder;
